import * as common from './common.json';

export const esMx = {
  common,
};
